/**
 * Created L/02/03/2020
 * Updated J/19/11/2020
 *
 * Copyright 2008-2021 | Fabrice Creuzot (luigifab) <code~luigifab~fr>
 * https://www.luigifab.fr/apijs
 *
 * This program is free software, you can redistribute it or modify
 * it under the terms of the GNU General Public License (GPL) as published
 * by the free software foundation, either version 2 of the license, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but without any warranty, without even the implied warranty of
 * merchantability or fitness for a particular purpose. See the
 * GNU General Public License (GPL) for more details.
 */

apijs.core.select = function () {

	"use strict";

	this.init = function () {

		document.querySelectorAll('select').forEach(function (elem) {
			elem.addEventListener('focus', apijs.select.open);
		});
	};

	this.open = function (ev) {

		var root = ev.target, t, a, b, c, d;

		t = document.createDocumentFragment();

			a = document.createElement('div');

				b = document.createElement('ul');
				root.querySelectorAll('option').forEach(function (elem) {
					c = document.createElement('li');
					c.appendChild(document.createTextNode(elem.textContent));
					Array.prototype.forEach.call(elem.attributes, function (attribute) {
						c.setAttribute(attribute.name, attribute.value);
					});
					this.appendChild(c);
				}, b); // pour que ci-dessus this = b

			a.appendChild(b);

		t.appendChild(a);

		console.log(t.firstChild.innerHTML);
		root.parentNode.replaceChild(t.firstChild, root);
	};
};